import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box, Button, CircularProgress, Typography } from "@mui/material"; // Dodano CircularProgress
import { Row } from "react-bootstrap";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import Nanny from "./Nanny";
import Aboutme from "./Aboutme";
import Cityuser from "./Cityuser";
import Qualifications from "./Qualifications";
import Experience from "./Experience";
import Languages from "./Languages";
import Endprofile from "./Endprofile";

function TabPanel(props) {
  const { children, value, index } = props;
  if (value !== index) return null;
  return <Box sx={{ p: 3 }}>{children}</Box>;
}

export default function ProfileTabs() {
  // Usunięto zbędne { props } jeśli ich nie używasz
  const [value, setValue] = useState(0);
  const [reloadList, setReloadList] = useState(0);
  const { userData } = useContext(UserDataContext);

  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTabTasks");
    if (savedTab !== null) {
      setValue(parseInt(savedTab));
    }
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("selectedTabTasks", newValue);

    if (newValue === 1) {
      setReloadList((prev) => prev + 1);
    }
  };

  // 1. Opcjonalne: Wyświetlanie ładowania, gdy userData jest jeszcze nullem
  if (!userData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <VN userData={userData} />

      {/* 2. Warunek sprawdzający UserId - upewnij się czy to UserId czy userId (w JS często małe u) */}
      {userData && userData.userId > 0 ? (
        <>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="underMenu"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
            >
              <Tab label="Dane personalne" />
              <Tab label="Co mogę zrobić?" />
              <Tab label="Gdzie mogę pracować?" />
              <Tab label="Kwalifikacje i uprawnienia" />
              <Tab label="Doświadczenie" />
              <Tab label="Języki obce" />
              <Tab label="Zakończenie edycji profilu" />
            </Tabs>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 2, // Zmieniono z height: 100% na padding, żeby przycisk nie "pływał"
            }}
          >
            <Button
              component={Link}
              to={`/portfolio/${userData.userId}`}
              variant="contained"
              size="large"
              sx={{
                backgroundColor: "green",
                "&:hover": { backgroundColor: "darkgreen" },
                px: 4,
                py: 1.5,
              }}
            >
              Podgląd profilu
            </Button>
          </Box>

          <TabPanel value={value} index={0}>
            <Row>
              <Aboutme />
            </Row>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Row>
              <Nanny reloadList={reloadList} />
            </Row>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Row>
              <Cityuser />
            </Row>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Row>
              <Qualifications reloadList={reloadList} />
            </Row>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <Row>
              <Experience />
            </Row>
          </TabPanel>
          <TabPanel value={value} index={5}>
            <Row>
              <Languages />
            </Row>
          </TabPanel>
          <TabPanel value={value} index={6}>
            <Row>
              <Endprofile />
            </Row>
          </TabPanel>
        </>
      ) : (
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography>Nie znaleziono danych użytkownika.</Typography>
        </Box>
      )}
    </div>
  );
}
